import type { IDeliveryLimits } from "@jti/magento";

export const searchForTheCity = (city: string, limits: IDeliveryLimits[]): number => {
  const regexp = new RegExp(city.replace(/(^\s+)|(\s+$)/g, ""), "i");
  return limits.filter((limit) => regexp.test(limit.name)).length;
};
